export const defaultInput = {

	data() {
		return {
			isFilling: false,
			checkFillingCount: true,
			isOverflow: false
		}
	},
	methods: {
		checkFilling(val) {
			this.$emit('userPhone', val);

			if (val !== null)
				val.length > 0 || typeof val === 'number' ?
					this.isFilling = true :
					this.isFilling = false;

		},

		checkOverflow(val) {
			const computedStyleInput = getComputedStyle(this.$refs.input);

			const widthInput = this.$refs.input.clientWidth
				- parseFloat(computedStyleInput.paddingRight)
				- parseFloat(computedStyleInput.paddingLeft);


			const inputFont = `${computedStyleInput.fontWeight} ${computedStyleInput.fontSize} ${computedStyleInput.fontFamily}`;

			const getTextWidth = (text, font) => {
				const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
				const context = canvas.getContext("2d");
				context.font = font;
				const metrics = context.measureText(text);
				return metrics.width;
			};

			const diff = () => (widthInput - getTextWidth(val, inputFont) - 15) <= 0;

			this.isOverflow = diff();
		},

	}


};

export const emailValidator = {
	data() {
		return {
			emailValidateText: 'createForm.formData.emailError'
		}
	},
	methods: {
		validateEmail(value) {
			const reg = /^([a-zA-Z0-9_\-\.\+]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,64})$/;
			const valid = reg.test(value);

			const toggleCondition = (param1, param2) => {
				this.inputsSettings.email.condition.error = param1;
				this.inputsSettings.email.condition.success = param2;
				this.inputsSettings.email.translation.errorText = this.emailValidateText;
			};

			if (value.length > 0) {
				valid && value.length <= 253 ?
					toggleCondition(false, true) :
					toggleCondition(true, false)

			} else {
				toggleCondition(false, false)
			}
		},
	},
};